// Import Actions
import { persistData, getPersistedData } from '../../util/persistor';

import { SET_ITEM, REMOVE_ITEM, SET_SHIPPING_ADDRESS, SET_SHIPPING_AMOUNT, SET_CART_SUBSCRIPTION, REMOVE_CART_SUBSCRIPTION, CLEAR_CART } from './CartActions';
import { APPLY_VOUCHER } from '../Voucher/VoucherActions';
import { INIT_PERSISTED_DATA } from '../App/AppActions';

// Initial State
export const initialState = {
    items: [],
    shipping: {
        address: {
            countryCode: '', // cca2 code like 'FR'
            postalCode: '', // string: '66000'
        },
        // carrier: ''
    },
    voucher: null,
    subscription: null,
};

const CartReducer = (state = initialState, action) => {
    switch(action.type) {
        case SET_ITEM: {
            const existingItem = state.items.find(item => item.productId === action.item.productId);
            const newState = {
                ...state,
                items: existingItem ? state.items.map(item => {
                    if(item.productId === action.item.productId) {
                        return action.item;
                    }
                    return item;
                }) : state.items.concat([action.item]),
            };
            persistData('cart', newState);
            return newState;
        }

        case REMOVE_ITEM: {
            const newState = {
                ...state,
                items: state.items.filter(item => item.productId !== action.item.productId),
                subscription: null,
            };
            persistData('cart', newState);
            return newState;
        }

        case CLEAR_CART: {
            const newState = {
                ...state,
                items: [],
                voucher: null,
                subscription: null,
            };
            persistData('cart', newState);
            return newState;
        }

        case SET_SHIPPING_ADDRESS: {
            const newState = {
                ...state,
                shipping: {
                    ...state.shipping,
                    address: action.address,
                },
            };
            persistData('cart', newState);
            return newState;
        }

        case SET_SHIPPING_AMOUNT: {
            const newState = {
                ...state,
                shipping: {
                    ...state.shipping,
                    amount: action.amount,
                },
            };
            persistData('cart', newState);
            return newState;
        }

        case APPLY_VOUCHER: {
            const newState = {
                ...state,
                voucher: action.voucher,
            };
            persistData('cart', newState);
            return newState;
        }

        case SET_CART_SUBSCRIPTION: {
            const newState = {
                ...state,
                subscription: action.subscription,
            };
            persistData('cart', newState);
            return newState;
        }

        case REMOVE_CART_SUBSCRIPTION: {
            const newState = {
                ...state,
                subscription: null,
            };
            persistData('cart', newState);
            return newState;
        }

        case INIT_PERSISTED_DATA:
            return getPersistedData('cart', initialState);

        default:
            return state;
    }
};

export default CartReducer;
